import { useLookbookWishlistContext } from '@app/components/lookbook/context/LookbookWishlistContext';
import { LookbookProductItemContextProvider } from '@app/components/products/context/LookbookProductItemContext';
import { Product } from '@typings';
import React from 'react';

import { ProductLargeCard } from './ProductLargeCard';
import { ProductMediumCard } from './ProductMediumCard';
import { ProductSmallCard } from './ProductSmallCard';

interface Props {
  productInfo: Product.Standard;
  gridSize?: 'small' | 'medium' | 'large';
}
interface SimpleProps {
  gridSize?: 'small' | 'medium' | 'large';
}

export const SimpleLookbookProductCard = React.memo(({ gridSize = 'medium' }: SimpleProps) => {
  const cardPerSize = {
    large: ProductLargeCard,
    medium: ProductMediumCard,
    small: ProductSmallCard,
  };

  const Card = cardPerSize[gridSize];

  return <Card />;
});
export const LookbookProductCard = React.memo(({ gridSize = 'medium', productInfo }: Props) => {
  const { wishlist, toggleProductInWishlist } = useLookbookWishlistContext();

  return (
    <LookbookProductItemContextProvider
      key={productInfo.product}
      productInfo={productInfo}
      wishlist={wishlist}
      toggleProductInWishlist={toggleProductInWishlist}
    >
      <SimpleLookbookProductCard gridSize={gridSize} />
    </LookbookProductItemContextProvider>
  );
});

export const ReadonlyLookbookProductCard = ({ gridSize = 'medium', productInfo }: Props) => {
  return (
    <LookbookProductItemContextProvider key={productInfo.product} productInfo={productInfo} isReadOnly>
      <SimpleLookbookProductCard gridSize={gridSize} />
    </LookbookProductItemContextProvider>
  );
};
